var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdificio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 127.954V34.6701C25 28.4511 31.25 22.2322 37.5 22.2322H68.75C75 22.2322 81.2497 28.4511 81.2497 34.6701V127.954",
    stroke: "white",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9998 47.108H112.5C118.75 47.108 125 53.3269 125 59.5457V127.954",
    stroke: "white",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 127.954H131.25",
    stroke: "white",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.75 62.7619C57.75 60.2889 59.7647 58.2842 62.25 58.2842C64.7353 58.2842 66.75 60.2889 66.75 62.7619C66.75 65.2348 64.7353 67.2395 62.25 67.2395C59.7647 67.2395 57.75 65.2348 57.75 62.7619Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 62.7619C38.25 60.2889 40.2647 58.2842 42.75 58.2842C45.2353 58.2842 47.25 60.2889 47.25 62.7619C47.25 65.2348 45.2353 67.2395 42.75 67.2395C40.2647 67.2395 38.25 65.2348 38.25 62.7619Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.75 78.4335C57.75 75.9603 59.7647 73.9559 62.25 73.9559C64.7353 73.9559 66.75 75.9603 66.75 78.4335C66.75 80.9066 64.7353 82.9111 62.25 82.9111C59.7647 82.9111 57.75 80.9066 57.75 78.4335Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 78.4335C38.25 75.9603 40.2647 73.9559 42.75 73.9559C45.2353 73.9559 47.25 75.9603 47.25 78.4335C47.25 80.9066 45.2353 82.9111 42.75 82.9111C40.2647 82.9111 38.25 80.9066 38.25 78.4335Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.75 94.1051C57.75 91.632 59.7647 89.6275 62.25 89.6275C64.7353 89.6275 66.75 91.632 66.75 94.1051C66.75 96.5782 64.7353 98.5827 62.25 98.5827C59.7647 98.5827 57.75 96.5782 57.75 94.1051Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 94.1051C38.25 91.632 40.2647 89.6275 42.75 89.6275C45.2353 89.6275 47.25 91.632 47.25 94.1051C47.25 96.5782 45.2353 98.5827 42.75 98.5827C40.2647 98.5827 38.25 96.5782 38.25 94.1051Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.75 109.777C57.75 107.304 59.7647 105.299 62.25 105.299C64.7353 105.299 66.75 107.304 66.75 109.777C66.75 112.25 64.7353 114.254 62.25 114.254C59.7647 114.254 57.75 112.25 57.75 109.777Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.75 109.777C99.75 107.304 101.765 105.299 104.25 105.299C106.735 105.299 108.75 107.304 108.75 109.777C108.75 112.25 106.735 114.254 104.25 114.254C101.765 114.254 99.75 112.25 99.75 109.777Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.75 94.1051C99.75 91.632 101.765 89.6275 104.25 89.6275C106.735 89.6275 108.75 91.632 108.75 94.1051C108.75 96.5782 106.735 98.5827 104.25 98.5827C101.765 98.5827 99.75 96.5782 99.75 94.1051Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.75 78.4335C99.75 75.9603 101.765 73.9559 104.25 73.9559C106.735 73.9559 108.75 75.9603 108.75 78.4335C108.75 80.9066 106.735 82.9111 104.25 82.9111C101.765 82.9111 99.75 80.9066 99.75 78.4335Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M99.75 62.7619C99.75 60.2889 101.765 58.2842 104.25 58.2842C106.735 58.2842 108.75 60.2889 108.75 62.7619C108.75 65.2348 106.735 67.2395 104.25 67.2395C101.765 67.2395 99.75 65.2348 99.75 62.7619Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 109.777C38.25 107.304 40.2647 105.299 42.75 105.299C45.2353 105.299 47.25 107.304 47.25 109.777C47.25 112.25 45.2353 114.254 42.75 114.254C40.2647 114.254 38.25 112.25 38.25 109.777Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.75 47.0902C57.75 44.6173 59.7647 42.6126 62.25 42.6126C64.7353 42.6126 66.75 44.6173 66.75 47.0902C66.75 49.5631 64.7353 51.5678 62.25 51.5678C59.7647 51.5678 57.75 49.5631 57.75 47.0902Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 47.0902C38.25 44.6173 40.2647 42.6126 42.75 42.6126C45.2353 42.6126 47.25 44.6173 47.25 47.0902C47.25 49.5631 45.2353 51.5678 42.75 51.5678C40.2647 51.5678 38.25 49.5631 38.25 47.0902Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdificio);
export default __webpack_public_path__ + "static/media/edificio.d36f8f4555a6fc44b4c2f73db6be95fb.svg";
export { ForwardRef as ReactComponent };